









import { Component, Prop, Vue, Provide } from 'vue-property-decorator';
import vmosServices from '@/services/vmosData';
import FlyoutGroup from './components/FlyoutGroup/FlyoutGroup.vue';
import { FlyoutData, FlyoutKeys, FlyoutDataI18n, FlyoutDataItem } from '@/lib/interfaces';

@Component({
  name: 'FlyoutWrapper',
  components: {
    FlyoutGroup,
  },
})
export default class FlyoutWrapper extends Vue {
  @Prop({ required: true, type: String }) private country!: string;
  @Prop({ required: true, type: String }) private language!: string;
  @Provide('i18n') private i18n: FlyoutDataI18n = { values: {} };
  private importedData: FlyoutData = {} as FlyoutData;
  //We use this variable to sort the different menu groups in a specified order
  private groupsSort: string[] = ['groups', 'filters', 'subGroups'];
  created(): void {
    this.loadData();
  }

  async loadData(): Promise<void> {
    this.importedData = await vmosServices.getLiveSummary({ market: this.country, language: this.language });
    this.i18n.values = this.importedData['i18n'];
  }

  get navCategories(): FlyoutDataItem {
    let categories = Object.keys(this.importedData)
      .filter((key) => key !== 'i18n')
      .sort((a: any, b: any) => {
        return this.groupsSort.indexOf(a) - this.groupsSort.indexOf(b);
      })
      .reduce((obj: any, key: any) => {
        obj[key] = this.importedData[key as FlyoutKeys];

        return obj;
      }, {});
    return categories;
  }
}
